export const dailyRewards = [
  {
    reward: "dealDucks",
    miniimg: "dealducks-image.webp",
    quantity: 10,
  },
  {
    reward: "dealDucks",
    miniimg: "dealducks-image.webp",
    quantity: 20,
  },
  {
    reward: "dealDucks",
    miniimg: "dealducks-image.webp",
    quantity: 30,
  },
  {
    reward: "dealDucks",
    miniimg: "dealducks-image.webp",
    quantity: 40,
  },
  {
    reward: "dealDucks",
    miniimg: "dealducks-image.webp",
    quantity: 50,
  },
  {
    reward: "dealDucks",
    miniimg: "dealducks-image.webp",
    quantity: 60,
  },
  {
    reward: "dealDucks",
    miniimg: "dealducks-image.webp",
    quantity: 70,
  },
];
